import React from "react";
import DonutChart from "./DonutChart";

const SummaryCard = ({dataInCard}) => {
  return (
    <div style={styles.card}>
      <div style={styles.chartContainer}>
        <DonutChart dataInCard={dataInCard} />
      </div>
      <div>
      <div style={styles.title}>{dataInCard?.occupiedHouses} Tenants</div>
      <div style={styles.subTitle}>Tenant information</div>
      </div>
      <div style={styles.detailsContainer}>
        <div style={styles.individualDetailContainer}>
          <div style={styles.title}>{dataInCard?.occupiedHouses + dataInCard?.vacantHouses}</div>
          <div style={styles.subTitle}>Houses</div>
        </div>
        <div style={styles.individualDetailContainer}>
          <div style={styles.title}>{dataInCard?.occupiedHouses}</div>
          <div style={styles.subTitle}>Occupied</div>
        </div>
        <div style={styles.individualDetailContainer}>
          <div style={styles.title}>{dataInCard?.vacantHouses}</div>
          <div style={styles.subTitle}>Vacant</div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  card: {
    width: "85%",
    height: "350px",
    background: "white",
    borderRadius: "10px",
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.28) ",
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  chartContainer: {
    height: "50%",
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontSize: "20px",
    color: "#333333",
    marginTop: "20px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "400",
    textAlign: "center",
  },
  subTitle: {
    fontSize: "15px",
    color: "#A8B4CC",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "row",
    width:"80%",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    
  },
  individualDetailContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
};

export default SummaryCard;
